import {
  type UseMutationOptions,
  useMutation,
  useQueryClient,
} from '@tanstack/vue-query'
import { employeeNotificationRead } from '../employeeNotificationEndpoints'
import {
  EMPLOYEE_NOTIFICATIONS_LATEST_QUERY_KEY,
  EMPLOYEE_NOTIFICATIONS_QUERY_KEY,
  EMPLOYEE_NOTIFICATIONS_UNREAD_COUNT_QUERY_KEY,
} from '../employeeNotificationQueryKeys'
import { axiosInstance } from '@/modules/Core/plugins/axios'

function invalidateEmployeeNotificationQueries(
  queryClient: ReturnType<typeof useQueryClient>
) {
  queryClient.invalidateQueries({
    queryKey: [EMPLOYEE_NOTIFICATIONS_QUERY_KEY],
  })
  queryClient.invalidateQueries({
    queryKey: [EMPLOYEE_NOTIFICATIONS_LATEST_QUERY_KEY],
  })
  queryClient.invalidateQueries({
    queryKey: [EMPLOYEE_NOTIFICATIONS_UNREAD_COUNT_QUERY_KEY],
  })
}

export function markEmployeeNotificationRead(id: number): Promise<void> {
  return axiosInstance.put(employeeNotificationRead(id)).then(() => undefined)
}

export function useMarkEmployeeNotificationReadMutation(
  options?: UseMutationOptions<void, AxiosCustomError, number>
) {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: markEmployeeNotificationRead,
    ...options,
    onSuccess: () => {
      invalidateEmployeeNotificationQueries(queryClient)
    },
  })
}
